import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=41dbe25e&"
import script from "./Friend.vue?vue&type=script&lang=js&"
export * from "./Friend.vue?vue&type=script&lang=js&"
import style0 from "./Friend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Friend.vue"
export default component.exports